import type { FormSchema } from '@cli-types/core-engine/schema.js'
import {
  FORM_SCHEMA_TITLE_FIELD_TYPES,
  GENERATED_SCHEMA_TITLE_FIELD_NAME
} from '@cli-constants/schema.js'
import { getAllFormSchemaFields } from '@core-engine/schema/field-helpers/form-fields/get-all-form-schema-fields.js'

export function hasFormSchemaTitleField(schema: FormSchema): boolean {
  return getAllFormSchemaFields(schema).some(
    (field) =>
      field.name === GENERATED_SCHEMA_TITLE_FIELD_NAME &&
      FORM_SCHEMA_TITLE_FIELD_TYPES.has(field.type)
  )
}
